import { render, staticRenderFns } from "./mpcdr.vue?vue&type=template&id=0650bd9e&scoped=true"
import script from "./mpcdr.vue?vue&type=script&lang=js"
export * from "./mpcdr.vue?vue&type=script&lang=js"
import style0 from "./mpcdr.vue?vue&type=style&index=0&id=0650bd9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650bd9e",
  null
  
)

export default component.exports